<template>
    <div v-show="visible">
        <el-dialog title="修改" :close-on-click-modal="false" v-loading="loading"  :visible.sync="visible" :before-close="dialogClose" width="370px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="140px">

                    <el-form-item   prop="classEvaluateTypeId" label="一级目录">
                        <el-select v-model="form.classEvaluateTypeId"  clearable style="width:200px;">
                            <el-option
                                v-for="item in classEvaluateTypes"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item   prop="evaluateId" label="关联二级目录">
                        <el-input placeholder="请选择指标" :readonly="true" v-model="form.evaluateTitle" class="input-with-select" style="width:200px;">
                            <el-button slot="append" icon="el-icon-search" @click="getEvaluate()"></el-button>
                        </el-input>
                    </el-form-item>

                    <el-form-item  prop="pictureNumSet" label="允许上传图片个数">
                        <el-input v-model="form.pictureNumSet" maxlength="1" type="number" style="width:200px;"></el-input>
                    </el-form-item>

                    <el-form-item  prop="orderNum" label="排序号">
                        <el-input v-model="form.orderNum" maxlength="20" type="number" style="width:200px;"></el-input>
                    </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
        <!-- 五育指标弹出框 -->
        <div v-if="evaluateIndicatorsDefineVisible">
            <evaluateIndicatorsDefine ref="evaluateIndicatorsDefine"></evaluateIndicatorsDefine>
        </div>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import evaluateIndicatorsDefine from './EvaluateIndicatorsDefine.vue';
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                loading:false,
                visible: false,
                evaluateIndicatorsDefineVisible:false,
                form:{
                    id:"",
                    deptId:"",
                    classEvaluateTypeId:"",
                    evaluateId:"",
                    evaluateTitle:"",
                    pictureNumSet:3,
                    orderNum:""
                },
                rules: {
                    classEvaluateTypeId: [
                        { required: true, message: '请选择一级目录', trigger: 'blur' }
                    ],
                    evaluateId:[
                        {required: true, message: '请选择关联二级目录', trigger: 'blur' }
                    ],
                    pictureNumSet: [
                        { required: true, message: '请输入允许上传图片个数', trigger: 'blur' }
                    ]
                },
                classEvaluateTypes:[],
            }
        },
        components: {
            evaluateIndicatorsDefine
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.id=data.id;
                this.form.deptId=data.deptId;
                this.form.classEvaluateTypeId=data.classEvaluateTypeId;
                this.form.evaluateId=data.evaluateId;
                this.form.evaluateTitle=data.name;
                this.form.pictureNumSet=data.pictureNumSet;
                this.form.orderNum=data.orderNum;
                // 加载班级分类
                this.getClassEvaluateType();
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getClassEvaluateType(){
                let url  = this.classEvaluateTypeListUrl;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.classEvaluateTypes = res.data.list;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        this.loading=true;
                        let url= this.classEvaluateIndicatorsSetUpdateUrl;
                        let data = {
                            id:this.form.id,
                            deptId:this.form.deptId,
                            classEvaluateTypeId:this.form.classEvaluateTypeId,
                            name:this.form.evaluateTitle,
                            evaluateId:this.form.evaluateId,
                            pictureNumSet:this.form.pictureNumSet,
                            orderNum:this.$util.isNotEmpty(this.form.orderNum)?this.form.orderNum:"",
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading=false;
                        }, (err) => {
                            console.log(err);
                            this.loading=false;
                        });
                    }
               });
            },
            getEvaluate(){
                this.evaluateIndicatorsDefineVisible=true;
                this.$nextTick(() => { 
                    this.$refs['evaluateIndicatorsDefine'].init(this.form.deptId);
                })
            },
            setEvaluate(key,label){
                this.form.evaluateId = key;
                this.form.evaluateTitle = label;
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/classset/UpdateIndicators.vue